<template>
  <div>
    <v-breadcrumbs :items="items"></v-breadcrumbs>
    <v-row>
      <v-col cols="12">
        <v-alert v-if="error_alert" text prominent type="error" icon="mdi-cloud-alert">{{
            error_alert
          }}</v-alert>
        <v-alert
            v-if="success_alert"
            text
            prominent
            type="success"
            icon="mdi-cloud-alert"
        >{{ success_alert }}</v-alert
        >
      </v-col>
      <v-col cols="6">
        <v-card-title>
          Operation Lists
          <v-spacer></v-spacer>
          <v-spacer></v-spacer>
          <v-spacer></v-spacer>
          <v-spacer></v-spacer>

          <template>
            <v-text-field
                v-model="search"
                prepend-icon="mdi-magnify"
                label="Search"
                single-line
                hide-details
                outlined
                dense
            ></v-text-field>
          </template>
          <v-spacer></v-spacer>
          <v-btn color="primary" @click="ot_list_print"
          ><v-icon>mdi-printer</v-icon></v-btn
          >
          <v-spacer></v-spacer>
          <v-btn color="primary" @click="ot_item_dialog = true"
          ><v-icon>mdi-plus</v-icon></v-btn
          >
        </v-card-title>

        <v-card>
          <v-data-table
              :headers="headers"
              :items="desserts"
              class="elevation-1"
              :search="search"
              dense
              mobile-breakpoint="0"
              :loading="loadingstatus"
              loading-text="Loading... Please wait"
          >
            <template v-slot:item.status="{ item }">
              <v-chip v-if="item.status == 1" dark color="green" label outlined small
              >Active
              </v-chip>
              <v-chip v-if="item.status == 0" dark color="orange" label outlined small
              >Inactive
              </v-chip>
            </template>
            <template v-slot:item.actions="{ item }">
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-chip
                      @click="get_update(item)"
                      dark
                      v-bind="attrs"
                      v-on="on"
                      class="ma-2"
                      color="orange"
                      label
                      outlined
                      small
                  ><v-icon> mdi-pencil </v-icon>
                  </v-chip>
                </template>
                <span>Edit</span>
              </v-tooltip>
              <!-- <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-chip
                    @click="add_siblings(item)"
                    dark
                    v-bind="attrs"
                    v-on="on"
                    class="ma-2"
                    color="primary"
                    label
                    outlined
                    small
                    ><v-icon> mdi-plus </v-icon>
                  </v-chip>
                </template>
                <span>Add Siblings</span>
              </v-tooltip> -->
            </template>
            <template v-slot:no-data>
              <v-btn color="primary" @click="get_operation_list()">Reset</v-btn>
            </template>
          </v-data-table>
        </v-card>
      </v-col>
      <v-col cols="6">
        <v-card-title
        >Operation: Bill Head
          <v-spacer></v-spacer>
          <v-spacer></v-spacer>
          <v-spacer></v-spacer>
          <v-spacer></v-spacer>
          <template>
            <v-text-field
                v-model="auto_search"
                prepend-icon="mdi-magnify"
                label="Search"
                single-line
                hide-details
                outlined
                dense
            ></v-text-field>
          </template>
          <v-spacer></v-spacer>
          <v-btn color="primary" @click="ot_bill_print"
          ><v-icon>mdi-printer</v-icon></v-btn
          >
          <v-spacer></v-spacer>
          <v-btn color="primary" @click="ot_bill_dialog = true"
          ><v-icon>mdi-plus</v-icon></v-btn
          >
        </v-card-title>
        <v-card>
          <v-data-table
              :headers="autoheaders"
              :items="autodesserts"
              class="elevation-1"
              :search="auto_search"
              dense
              mobile-breakpoint="0"
              :loading="loadingstatus"
              loading-text="Loading... Please wait"
          >
            <template v-slot:item.status="{ item }">
              <v-chip v-if="item.status == 1" dark color="green" label outlined small
              >Active
              </v-chip>
              <v-chip v-if="item.status == 0" dark color="orange" label outlined small
              >Inactive
              </v-chip>
            </template>
            <template v-slot:item.actions="{ item }">
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-chip
                      @click="getUpdateOTBillHead(item)"
                      dark
                      v-bind="attrs"
                      v-on="on"
                      class="ma-2"
                      color="orange"
                      label
                      outlined
                      small
                  ><v-icon> mdi-pencil </v-icon>
                  </v-chip>
                </template>
                <span>Edit</span>
              </v-tooltip>
            </template>

            <template v-slot:no-data>
              <v-btn color="primary" @click="get_operation_bill_head">Reset</v-btn>
            </template>
          </v-data-table>
        </v-card>
      </v-col>
      <v-col cols="6">
        <v-card-title
        >Lens Setup: Vendor
          <v-spacer></v-spacer>
          <v-spacer></v-spacer>
          <v-spacer></v-spacer>

          <template>
            <v-text-field
                v-model="auto_search"
                prepend-icon="mdi-magnify"
                label="Search"
                single-line
                hide-details
                outlined
                dense
            ></v-text-field>
            <v-spacer></v-spacer>
            <v-btn color="primary" @click="addVendor">Add Vendor</v-btn>
          </template>
        </v-card-title>
        <v-card>
          <v-data-table
              :headers="lensVendors"
              :items="lensVendorLists"
              class="elevation-1"
              :search="auto_search"
              dense
              mobile-breakpoint="0"
              :loading="loadingstatus"
              loading-text="Loading... Please wait"
          >
            <template v-slot:item.status="{ item }">
              <v-chip
                  v-if="item.status == 1"
                  dark
                  color="green"
                  label
                  outlined
                  small
              >Active
              </v-chip>
              <v-chip
                  v-if="item.status == 0"
                  dark
                  color="orange"
                  label
                  outlined
                  small
              >Inactive
              </v-chip>
            </template>
            <template v-slot:item.actions="{ item }">
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-chip
                      @click="editVendorsData(item)"
                      dark
                      v-bind="attrs"
                      v-on="on"
                      class="ma-2"
                      color="orange"
                      label
                      outlined
                      small
                  >
                    <v-icon> mdi-pencil</v-icon>
                  </v-chip>
                </template>
                <span>Edit</span>
              </v-tooltip>
            </template>
            <template v-slot:no-data>
              <v-btn color="primary" @click="getLensBrandVendorList">Reset</v-btn>
            </template>
          </v-data-table>
        </v-card>
      </v-col>
      <v-col cols="6">
        <v-card-title
        >Lens Setup :Brand
          <v-spacer></v-spacer>
          <v-spacer></v-spacer>
          <v-spacer></v-spacer>

          <template>
            <v-text-field
                v-model="auto_search"
                prepend-icon="mdi-magnify"
                label="Search"
                single-line
                hide-details
                outlined
                dense
            ></v-text-field>
            <v-spacer></v-spacer>
            <v-btn color="primary" @click="addBrand">Add Brand</v-btn>
          </template>
        </v-card-title>
        <v-card>
          <v-data-table
              :headers="lensVendors"
              :items="lensBrandLists"
              class="elevation-1"
              :search="auto_search"
              dense
              mobile-breakpoint="0"
              :loading="loadingstatus"
              loading-text="Loading... Please wait"
          >
            <template v-slot:item.status="{ item }">
              <v-chip
                  v-if="item.status == 1"
                  dark
                  color="green"
                  label
                  outlined
                  small
              >Active
              </v-chip>
              <v-chip
                  v-if="item.status == 0"
                  dark
                  color="orange"
                  label
                  outlined
                  small
              >Inactive
              </v-chip>
            </template>
            <template v-slot:item.actions="{ item }">
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-chip
                      @click="editBrandData(item)"
                      dark
                      v-bind="attrs"
                      v-on="on"
                      class="ma-2"
                      color="orange"
                      label
                      outlined
                      small
                  >
                    <v-icon> mdi-pencil</v-icon>
                  </v-chip>
                </template>
                <span>Edit </span>
              </v-tooltip>
            </template>
            <template v-slot:no-data>
              <v-btn color="primary" @click="getLensBrandVendorList">Reset</v-btn>
            </template>
          </v-data-table>
        </v-card>
      </v-col>
    </v-row>
    <template>
      <div class="text-center">
        <v-dialog v-model="dialog" width="500">
          <v-card>
            <v-card-title class="text-h5 grey lighten-2"> OT Lens: {{ lensDataVrBr }}</v-card-title>
            <template>
              <v-form>
                <v-container>
                  <v-row>
                    <v-col cols="12">
                      <v-text-field
                          v-model="formData.name"
                          outlined
                          dense
                          label="Name"
                          required
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" md="6">
                      <v-text-field
                          v-model="formData.group"
                          outlined
                          dense
                          label="Group"
                          required
                          readonly
                      ></v-text-field>
                    </v-col>

                    <v-col cols="12" md="6">
                      <v-select
                          v-model="formData.status"
                          :items="status"
                          label="Status"
                          item-value="key"
                          item-text="value"
                          outlined
                          dense
                      ></v-select>
                    </v-col>
                  </v-row>
                </v-container>
              </v-form>
            </template>
            <v-divider></v-divider>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn text @click="resetSubmitForm"> Cancel</v-btn>
              <v-btn color="primary" text @click="formSubmit()"> Submit</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </div>
    </template>
    <template>
      <div class="text-center">
        <v-dialog v-model="ot_item_dialog" width="500">
          <v-card>
            <v-card-title class="text-h5 grey lighten-2">
              OT Item
              <span v-if="otItemData.name">: {{ otItemData.name }}</span></v-card-title
            >
            <template>
              <v-form>
                <v-container>
                  <v-row>
                    <v-col cols="12">
                      <v-text-field
                          v-model="otItemData.name"
                          outlined
                          dense
                          label="Item Name"
                          required
                      ></v-text-field>
                      <v-select
                          :items="otItemCategory"
                          item-text="content"
                          v-model="otItemData.category"
                          outlined
                          dense
                          label="Item Category"
                          required
                      ></v-select>
                    </v-col>
                    <v-col cols="12" md="6">
                      <v-select
                          :items="otItemType"
                          item-text="content"
                          v-model="otItemData.op_type"
                          outlined
                          dense
                          label="Item Type"
                          required
                      ></v-select>
                    </v-col>

                    <v-col cols="12" md="6">
                      <v-select
                          v-model="otItemData.status"
                          :items="status"
                          item-value="key"
                          item-text="value"
                          label="Item Status"
                          outlined
                          dense
                      ></v-select>
                    </v-col>
                  </v-row>
                </v-container>
              </v-form>
            </template>
            <v-divider></v-divider>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn text @click="ot_item_dialog = false"> Cancel </v-btn>
              <v-btn text color="warning" @click="otItemData = {}"> Reset </v-btn>
              <v-btn color="primary" text @click="otItemSubmit()"> Submit </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </div>
    </template>
    <template>
      <div class="text-center">
        <v-dialog v-model="ot_bill_dialog" width="500">
          <v-card>
            <v-card-title class="text-h5 grey lighten-2">
              OT Bill Head
              <span v-if="otBillHeadData.name"
              >: {{ otBillHeadData.name }}</span
              ></v-card-title
            >
            <template>
              <v-form>
                <v-container>
                  <v-row>
                    <v-col cols="12">
                      <v-text-field
                          v-model="otBillHeadData.ledger_name"
                          outlined
                          dense
                          label="Ledger Name"
                          required
                      ></v-text-field>
                      <v-autocomplete
                          v-model="otBillHeadData.operation_id"
                          item-text="name"
                          item-value="id"
                          :items="operation_list"
                          label="operation Name"
                          outlined
                          dense
                          :loading="loadingstatus"
                      ></v-autocomplete>
                      <v-text-field
                          v-model="otBillHeadData.amount"
                          outlined
                          dense
                          label="OT Charge"
                          required
                      ></v-text-field>
                      <v-select
                          :items="otItemCategory"
                          item-text="content"
                          v-model="otBillHeadData.operation_type"
                          outlined
                          dense
                          label="Item Category"
                          required
                      ></v-select>
                    </v-col>
                    <v-col cols="12" md="6">
                      <v-select
                          item-value="key"
                          item-text="value"
                          :items="otChargeFixed"
                          v-model="otBillHeadData.amount_fixed"
                          outlined
                          dense
                          label="OT Charge Fixed"
                          required
                      ></v-select>
                    </v-col>
                    <v-col cols="12" md="6">
                      <v-select
                          v-model="otBillHeadData.status"
                          :items="status"
                          item-value="key"
                          item-text="value"
                          label="Item Status"
                          outlined
                          dense
                      ></v-select>
                    </v-col>
                  </v-row>
                </v-container>
              </v-form>
            </template>
            <v-divider></v-divider>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn text @click="ot_bill_dialog = false"> Cancel </v-btn>
              <v-btn text color="warning" @click="otBillHeadData = {}"> Reset </v-btn>
              <v-btn color="primary" text @click="otBillHeadSubmit()"> Submit </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </div>
    </template>
  </div>
</template>

<style scoped>
.layout {
  display: inline-block;
  width: 100%;
}
</style>
<script>
import atshq from "../../../js/setup";
export default {
  data() {
    return {
      search: "",
      auto_search: "",
      dialog: false,
      ot_item_dialog: false,
      ot_bill_dialog: false,
      slibling_dialog: false,
      error_alert: null,
      success_alert: null,
      loadingstatus: true,
      operation_list: [],
      status: [
        {key: 1, value: "Active"},
        {key: 0, value: "Inactive"},
      ],
      headers: [
        { text: "Operation Name", value: "name" },
        { text: "Category", value: "category" },
        { text: "Type", value: "op_type" },
        { text: "Status", value: "status" },
        { text: "Action", value: "actions", sortable: false },
      ],
      desserts: [],
      lensVendorLists: [],
      lensBrandLists: [],
      lensSetuplist: [],
      lensDataVrBr:'',
      autoheaders: [
        {
          text: "ID",
          align: "start",
          sortable: false,
          value: "id",
        },
        { text: "Ledger Name", value: "ledger_name" },
        { text: "OT Charge", value: "amount" },
        { text: "Category", value: "operation_type" },
        { text: "Status", value: "status" },
        { text: "Auto Gen Operation", value: "operation.name" },

        { text: "Action", value: "actions", sortable: false },
      ],
      autodesserts: [],
      formData: {
        id: null,
        name: null,
        group: null,
        status: null,
      },
      lensVendors: [
        {
          text: "ID",
          align: "start",
          sortable: false,
          value: "id",
        },
        {text: "Name", value: "name"},
        {text: "Status", value: "status"},
        {text: "Action", value: "actions", sortable: false},
      ],
      lensBrands: [
        {
          text: "ID",
          align: "start",
          sortable: false,
          value: "id",
        },
        {text: "Name", value: "name"},
        {text: "Status", value: "status"},
        {text: "Action", value: "actions", sortable: false},
      ],

      otItemCategory: {},
      otItemType: {},
      otChargeFixed: [
        { key: 1, value: "Yes" },
        { key: 0, value: "No" },
      ],
      otItemData: {
        id: null,
        name: null,
        description: null,
        category: null,
        op_type: null,
        status: null,
      },
      otBillHeadData: {
        id: null,
        ledger_name: null,
        operation_id: null,
        ledger_type: null,
        operation_type: null,
        amount_fixed: null,
        status: null,
      },

      items: [
        {
          text: "Dashboard",
          disabled: false,
          href: "/",
        },
        {
          text: "Operations",
          disabled: true,
          href: "patients",
        },
      ],
      returnUrl: atshq.defaults.headers.common.app_URL,
    };
  },
  // Fetches posts when the component is created.
  created() {
    this.permissionCheck();
    this.get_operation_list();
    this.get_operation_bill_head();
    this.getLensSetup();
    this.getOtItemCategory();
    this.getotItemType();
    this.getLensBrandVendorList();
  },
  methods: {
    permissionCheck() {
      atshq
          .get("users/user-group?id=" + localStorage.getItem("userId"))
          .then((response) => {
            if (!(response.data.data.includes("ot-setup") || response.data.data.includes("admin"))) {
              this.$router.go(-1);
            }
          })
          .catch((e) => {
            this.errors.push(e);
          });
    },
    get_operation_list() {
      atshq
          .get("operation/item-list")
          .then((response) => {
            this.operation_list = response.data.data;
            this.desserts = response.data.data;

            this.loadingstatus = false;
          })
          .catch((e) => {
            this.error_alert.push(e);
          });
    },
    get_operation_bill_head() {
      atshq
          .get("ot-module/ot-bill-head")
          .then((response) => {
            this.autodesserts = response.data.data;
            this.loadingstatus = false;
          })
          .catch((e) => {
            this.error_alert.push(e);
          });
    },
    getLensSetup() {
      atshq
          .get("lens/lens-setup")
          .then((response) => {
            this.lensSetuplist = response.data.data;
            this.loadingstatus = false;
          })
          .catch((e) => {
            this.error_alert.push(e);
          });
    },
    getOtItemCategory() {
      atshq
          .get("lens/lens-setup?group_name=ot-item-category&status=Active")
          .then((response) => {
            this.otItemCategory = response.data.data;
            this.loadingstatus = false;
          })
          .catch((e) => {
            this.error_alert.push(e);
          });
    },
    getotItemType() {
      atshq
          .get("lens/lens-setup?group_name=ot-item-type&status=Active")
          .then((response) => {
            this.otItemType = response.data.data;
            this.loadingstatus = false;
          })
          .catch((e) => {
            this.error_alert.push(e);
          });
    },
    get_update(items) {
      this.ot_item_dialog = true;
      this.otItemData = items;
    },
    getUpdateOTBillHead(items) {
      this.ot_bill_dialog = true;
      this.otBillHeadData = items;
    },
    getLensBrandVendorList() {
      atshq
          .get("lens/lens-vendor-brand-list")
          .then((response) => {
            this.lensBrandLists = response.data.lensBrandLists;
            this.lensVendorLists = response.data.lensVendorLists;
            this.loadingstatus = false;
          })
          .catch((e) => {
            this.error_alert.push(e);
          });
    },

    addVendor() {
      this.dialog = true;
      this.lensDataVrBr = "Vendor";
      this.formData.group = "Vendor";
    },
    addBrand() {
      this.dialog = true;
      this.lensDataVrBr = "Brand";
      this.formData.group = "Brand";
    },
    resetSubmitForm() {
      this.dialog = false;
      this.lensDataVrBr = '';
      this.formData.id = null;
      this.formData.group = null;
      this.formData.name = null;
      this.formData.status = null;
    },
    editVendorsData(items) {
      this.dialog = true;
      this.lensDataVrBr = 'Edit Vendor';
      this.formData.group = 'Vendor';
      this.formData.id = items.id;
      this.formData.name = items.name;
      this.formData.status = items.status;
    },
    editBrandData(items) {
      this.dialog = true;
      this.lensDataVrBr = 'Edit Brand';
      this.formData.group = 'Brand';
      this.formData.id = items.id;
      this.formData.name = items.name;
      this.formData.status = items.status;
    },

    formSubmit() {
      if (confirm("are you sure?"))
        if (this.formData.id) {
          atshq
              .put("lens/lens-setup/" + this.formData.id, {
                formData: this.formData,
                user_id: localStorage.getItem("userId"),
              })
              .then((response) => {
                this.$noty.success(response.data.message);
                this.dialog = false;
                this.resetSubmitForm();
                this.getLensBrandVendorList();
              })
              .catch((e) => {
                this.$noty.error(e.response.data.message)
                this.getLensBrandVendorList();
                this.errors.push(e);
              })
        } else {
          atshq
              .post("lens/lens-setup", {
                formData: this.formData,
                user_id: localStorage.getItem("userId"),
              })
              .then((response) => {
                this.$noty.success(response.data.message);
                this.dialog = false;
                this.resetSubmitForm();
                this.getLensBrandVendorList();
              })
              .catch((e) => {
                this.$noty.error(e.response.data.message)
                this.getLensBrandVendorList();
                this.errors.push(e);
              })
        }


    },
    otItemSubmit() {
      if (confirm("are you sure?"))
        if (this.otItemData.id) {
          atshq
              .put("operations/" + this.otItemData.id, {
                data: this.otItemData,
                user_id: localStorage.getItem("userId"),
              })
              .then((res) => {
                if (res.status == 200) {
                  this.$noty.success("Successfuly Updated!");
                  this.success_alert = res.data.messages;
                  this.get_operation_list();
                  this.ot_item_dialog = false;
                }
              })
              .catch((e) => {
                this.$noty.error("Oops, something went wrong!");
                this.errors.push(e);
              })
              .finally(() => {
                //Perform action in always
              });
        } else {
          atshq
              .post("operations", {
                data: this.otItemData,
                user_id: localStorage.getItem("userId"),
              })
              .then((res) => {
                if (res.status == 200) {
                  this.$noty.success("Successfuly saved!");
                  this.success_alert = res.data.messages;
                  this.get_operation_list();
                  this.ot_item_dialog = false;
                }
              })
              .catch((e) => {
                this.$noty.error("Oops, something went wrong!");
                this.errors.push(e);
              })
              .finally(() => {
                //Perform action in always
              });
        }
    },
    otBillHeadSubmit() {
      if (confirm("are you sure?"))
        if (this.otBillHeadData.id) {
          atshq
              .put("ot-module/ot-bill-head/" + this.otBillHeadData.id, {
                data: this.otBillHeadData,
                user_id: localStorage.getItem("userId"),
              })
              .then((res) => {
                if (res.status == 200) {
                  this.$noty.success("Successfuly Updated!");
                  this.success_alert = res.data.messages;
                  this.get_operation_bill_head();
                  this.ot_bill_dialog = false;
                }
              })
              .catch((e) => {
                this.$noty.error("Oops, something went wrong!");
                this.errors.push(e);
              })
              .finally(() => {
                //Perform action in always
              });
        } else {
          atshq
              .post("ot-module/ot-bill-head", {
                data: this.otBillHeadData,
                user_id: localStorage.getItem("userId"),
              })
              .then((res) => {
                if (res.status == 200) {
                  this.$noty.success("Successfuly saved!");
                  this.success_alert = res.data.messages;
                  this.get_operation_bill_head();
                  this.ot_bill_dialog = false;
                }
              })
              .catch((e) => {
                this.$noty.error("Oops, something went wrong!");
                this.errors.push(e);
              })
              .finally(() => {
                //Perform action in always
              });
        }
    },
    ot_list_print() {
      window.open(this.returnUrl + "printdoc/operation_list");
    },
    ot_bill_print() {
      window.open(this.returnUrl + "printdoc/operation_bill_head_list");
    },
  },
};
</script>
